export enum DefaultsEnum {
  LONG_TOAST_DURATON = 4500,
  SHORT_TOAST_DURATON = 2500,
}
